import * as Immutable from 'immutable';

export interface IUserPrefsStore {
	name: string,
	lang: string,
	currency: string,
	newsletter: string
}

const defaultStore = Immutable.Record<IUserPrefsStore>({
	name: "",
	lang: "en_CA",
	currency: "",
	newsletter: "",
});

export default class UserPrefsStore extends defaultStore implements IUserPrefsStore {}